import type { UserStatusCounts } from "../types/users-api.types";

/**
 * How many rows fall in a status bucket that has no tile of its own.
 *
 * `counts.all` is accumulated by the backend over EVERY status bucket, including one added to the enum by a
 * later migration — its own comment says such a value "has no chip of its own yet, which is honest". So the
 * four tiles stop summing to Total the day that happens, and the Total tile discloses the difference instead
 * of the strip silently under-reporting.
 */
export function statusResidual(counts: UserStatusCounts): number {
  const tiled = counts.active + counts.inactive + counts.suspended + counts.pending_verification;
  return Math.max(0, counts.all - tiled);
}

/**
 * Renders a count, or an em-dash when it could not be read.
 *
 * `0` and `null` are different answers and must never collapse: a zero on "Suspendidos" states that nobody is
 * suspended, which is the opposite of "we could not ask". This is one `??` away from being wrong, which is
 * why it is a named function with a test rather than an inline expression.
 */
export function formatCount(value: number | null | undefined): string {
  return typeof value === "number" ? String(value) : "—";
}
